var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonoutlinegreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 2.66675C6.52663 2.66675 5.33329 3.86008 5.33329 5.33341C5.33329 6.80675 6.52663 8.00008 7.99996 8.00008C9.47329 8.00008 10.6666 6.80675 10.6666 5.33341C10.6666 3.86008 9.47329 2.66675 7.99996 2.66675ZM9.33329 5.33341C9.33329 4.60008 8.73329 4.00008 7.99996 4.00008C7.26663 4.00008 6.66663 4.60008 6.66663 5.33341C6.66663 6.06675 7.26663 6.66675 7.99996 6.66675C8.73329 6.66675 9.33329 6.06675 9.33329 5.33341ZM12 11.3334C11.8666 10.8601 9.79996 10.0001 7.99996 10.0001C6.19996 10.0001 4.13329 10.8601 3.99996 11.3401V12.0001H12V11.3334ZM2.66663 11.3334C2.66663 9.56008 6.21996 8.66675 7.99996 8.66675C9.77996 8.66675 13.3333 9.56008 13.3333 11.3334V13.3334H2.66663V11.3334Z",
    fill: "#0D4248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonoutlinegreen);
export default __webpack_public_path__ + "static/media/Personoutlinegreen.c1924ba68ab16ee18bf9cb6dcf372b1a.svg";
export { ForwardRef as ReactComponent };